import React from 'react';
import Icon from '../../../components/AppIcon';

const EngagementMetricsPanel = ({ data }) => {
  const metrics = [
    {
      label: 'Avg Session Duration',
      value: `${data?.avgSessionDuration} min`,
      icon: 'Clock',
      color: 'blue'
    },
    {
      label: 'Retention Rate',
      value: `${data?.retentionRate}%`,
      icon: 'Users',
      color: 'green'
    },
    {
      label: 'Churn Rate',
      value: `${data?.churnRate}%`,
      icon: 'UserMinus',
      color: 'red'
    },
    {
      label: 'Feature Adoption',
      value: `${data?.featureAdoptionRate}%`,
      icon: 'Zap',
      color: 'purple'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    red: 'bg-red-50 text-red-600',
    purple: 'bg-purple-50 text-purple-600'
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-purple-50 rounded-lg">
          <Icon name="Activity" className="w-5 h-5 text-purple-600" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Engagement Metrics</h2>
          <p className="text-sm text-gray-500">User activity and retention insights</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {metrics?.map((metric, index) => (
          <div key={index} className="p-4 border border-gray-200 rounded-lg hover:border-gray-300 transition-colors">
            <div className="flex items-center gap-3 mb-2">
              <div className={`p-2 rounded-lg ${colorClasses?.[metric?.color]}`}>
                <Icon name={metric?.icon} className="w-4 h-4" />
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-1">{metric?.label}</p>
            <p className="text-xl font-bold text-gray-900">{metric?.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EngagementMetricsPanel;